import { queryOptions, useQuery } from '@tanstack/react-query';

import { returnsApi } from '../api/returns-api';

import { returnKeys } from './return-keys';

export function returnQueryOptions(storeId: string, id: string) {
  return queryOptions({
    queryKey: returnKeys.detail(storeId, id),
    queryFn: () => returnsApi.get(storeId, id),
  });
}

export function useReturn(storeId: string, id: string) {
  return useQuery(returnQueryOptions(storeId, id));
}
